import React from 'react'
import swal from "sweetalert2"
export function showErrorWithCode(errCode) {
  let errorMess
  switch (errCode) {
    case 'not_logged_in':
      errorMess = 'Bạn chưa đăng nhập'
      break;
    case 'missing_account_id':
      errorMess = 'Tài khoản này chưa có HLV, vui lòng tạo HLV và quay lại sau'
      break;
    case 'server_error':
      errorMess = 'Xảy ra lỗi, hãy thử lại sau!'
      break;
    case 'api_error':
      errorMess = 'Thao tác không thực hiện được, xin vui lòng thử lại sau'
      break;
    case 'update_info_required':
      errorMess = 'Vui lòng cập nhật thông tin'
      break;
    case 'error_zero_spin':
      errorMess = 'Bạn đã hết lượt quay'
      break;
    case 'invalid_action':
      errorMess = 'Thao tác không thực hiện được'
      break;
    case 'event_not_open_yet':
      errorMess = 'Sự kiện chưa bắt đầu'
      break;
    case 'already_shared':
      errorMess = 'Bạn đã share thành công và đóng góp cổ vũ ngày hôm nay.'
      break;
    case 'not_enough_shoot_balance':
      errorMess = 'Bạn đã hết lượt nã pháo'
      break;
    case 'error_reward_not_found':
      errorMess = 'Phần quà không tồn tại'
      break;
    case 'match_ended':
      errorMess = 'Trận đấu đã kết thúc.'
      break;
    case 'time_is_up':
      errorMess = 'Đã hết thời gian dự đoán trận đấu này.'
      break;
    case 'error_not_enough_point':
      errorMess = 'Bạn không đủ điểm để đổi vật phẩm.'
      break;
    case 'error_limit_exchange':
      errorMess = 'Bạn đã đổi vật phẩm này. Hãy chọn vật phẩm khác nhé.'
      break;
    case 'error_not_enough_fc':
      errorMess = 'Bạn không đủ FC, vui lòng nạp thêm FC và thử lại.'
      break;
    case 'error_have_exchanged':
      errorMess = 'Bạn đã đổi quà này rồi.'
      break;
    case 'error_time_invalid':
      errorMess = 'Thời gian sự kiện đã kết thúc, cảm ơn bạn đã quan tâm.'
      break;
    default:
      errorMess = 'Có lỗi xảy ra. Vui lòng thử lại sau';
      break;
  }
  return errorMess
}


var imgCDN = '/'
// var imgCDN = 'https://cdn.vn.garenanow.com/web/fo3/fo4/fo4-super-spin/'
export function smoothScroll(target) {
  if (!target) {
    return
  }
  $('html,body').stop().animate({
    scrollTop: $(target).offset().top - $('header').height()
  }, 1000);
}

export function commingSoonFnc() {
  swal({
    title: 'Thông báo',
    html: '<p class="pop-content">Sự kiện sẽ bắt đầu vào 11h00 ngày 30/10/2019</p>',
    animation: false,
    confirmButtonText: 'Đóng',
    customClass: 'custom-modal animated zoomIn'
  })
  return
}
export function inWords(num) {
  if (num >= 1e12) return `${Math.floor(num / 1e12)} nghìn tỷ`
  if (num >= 1e9) return `${Math.floor(num / 1e9)} tỷ`
  if (num >= 1e6) return `${Math.floor(num / 1e6)} triệu`
  if (num >= 1e3) return `${Math.floor(num / 1e9)} nghìn`
  else {
    num = 0
  }
  return num
}
export function formatNumber(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
}
export function img(src, imgClass) {
  return <img className={imgClass ? imgClass : ''} src={imgCDN + src} alt="" />
}
export const isStartEvent = true


// WEBPACK FOOTER //
// ./src/components/common.js